import { useAudioPlayer } from 'app/components/AudioPlayer/hooks';
import { useAppSelector } from 'app/store';
import {
  getAudioPlayer,
  getIsPlayerLoading,
  getPlayerCurrentAudio,
} from 'app/store/AudioPlayer/selectors';
import { GenericObject } from 'types/generic.types';
import { Song } from 'types/song';

interface SongDetails {
  status?: Song['status'];
  title?: Song['title'];
}

interface UseRowRendererProps {
  audioGuid?: string;
  playlistAudioGuid?: string;
  parentGuid: string;
  handleAudioLoad?: () => void;
  songDetails?: SongDetails;
  versionSongGuid?: string;
}

export const useAudioPlayHook = ({
  playlistAudioGuid,
  parentGuid,
  audioGuid,
  handleAudioLoad,
  songDetails,
  versionSongGuid,
}: UseRowRendererProps) => {
  const currentAudio = useAppSelector(getPlayerCurrentAudio);
  const { isPlaying: isAudioPlaying } = useAppSelector(getAudioPlayer);
  const isPlayerLoading = useAppSelector(getIsPlayerLoading);
  const { loadAudio, playPauseAudio } = useAudioPlayer();

  const guid = playlistAudioGuid || audioGuid;
  const activeGuid = currentAudio?.playlistAudioGuid || currentAudio?.audioGuid;

  const isLoading = (currentlyReplacingAudio: GenericObject<boolean>) =>
    (isPlayerLoading && audioGuid === activeGuid) ||
    '' ||
    (guid && currentlyReplacingAudio[guid]);

  const handlePlay = async (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    try {
      e.stopPropagation();
      e.preventDefault();

      if (!audioGuid) {
        return;
      }

      if (activeGuid === guid) {
        playPauseAudio();
      } else {
        if (typeof handleAudioLoad === 'function') {
          handleAudioLoad();
          return;
        }
        await loadAudio({
          audio: [
            {
              audioGuid,
              playlistAudioGuid,
              songStatus: songDetails?.status,
              parentGuid,
              songTitle: songDetails?.title,
              versionSongGuid,
            },
          ],
        });
      }
    } catch {
      // proceed
    }
  };

  const isPlaying = isAudioPlaying && activeGuid === guid;
  const isActive = activeGuid === guid;

  return { handlePlay, isLoading, isPlaying, isActive };
};
